import { render, staticRenderFns } from "./QualificationsPanel.vue?vue&type=template&id=21b9dfca&"
import script from "./QualificationsPanel.vue?vue&type=script&lang=js&"
export * from "./QualificationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports